module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAs0lEQVQ4T+3UQQoCIRQG4P+R+3ApHaLu5Cq6QEETUotOEM0svMCcpu5QuZT2kmFQRIuo6V/mUvTzV95TQB5C9iBt2/ZijEsAEwD9jgecAWy01gtpmmYKYN0Ret02K+ABwIAEHgt4AcB6y1zATEp3Y1jJHpn4IP3Kf/BtBSmlRtba/fMi7/0wpbS7z31Vh5+C9E45ATCkbglS1/VcRFYMMOdciXNOGWMKOP7xP9yGECp6610BqqtLmXE06UgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgage/icon_card.png
// module id = 1J1E
// module chunks = 1